export const FEE_MIN_VALUE = 0;
export const FEE_MAX_VALUE = 500;
